export default {
  saveRecipeAs: {
    header: 'Zapisz przepis jako',
  },
};
